import { Avatar, Clickable, Icon } from 'components';
import { imageResizer } from 'core';
import { theme } from 'lib';
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: relative;
  width: 72px;
`;

const IconContainer = styled.div`
  position: absolute;
  right: -5px;
  bottom: -5px;
  background-color: ${theme.SECONDARY};
  height: 40px;
  width: 40px;
  border-radius: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ChangeAvatar = ({ user, onFileSelect }) => {
  const [avatar, setAvatar] = useState(null),
    [preview, setPreview] = useState(null),
    fileInput = useRef();

  useEffect(() => {
    if (avatar === user?.avatar) return;
    setAvatar(user?.avatar);
  }, [user?.avatar]);

  async function handleFile(e) {
    const file = e?.target?.files[0];
    if (!file) return;
    let files = [];

    const image = await imageResizer({
      height: 400,
      width: 400,
      format: 'png',
      file,
      output: 'blob',
      quality: 50
    });

    setAvatar(image);
    setPreview(URL.createObjectURL(image));
    onFileSelect && onFileSelect(image);
  }

  function openFilePicker() {
    fileInput.current.click();
  }

  return (
    <Wrapper>
      <Avatar user={user} avatar={preview} />

      <Clickable onClick={openFilePicker}>
        <IconContainer>
          <Icon type="edit" dimensions={18} col="#fff" />
        </IconContainer>
      </Clickable>

      <input
        type="file"
        ref={fileInput}
        style={{ display: 'none' }}
        onChange={(event) => handleFile(event)}
      />
    </Wrapper>
  );
};

export default ChangeAvatar;
